// extracted by mini-css-extract-plugin
module.exports = {"loginContent":"DonationUserLoginSection_loginContent__30Kvx","link":"DonationUserLoginSection_link__2LxtA","loginPrompt":"DonationUserLoginSection_loginPrompt__k6kHl"};